import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/main/shared/services/data.service';
import { GisDimsMapComponent } from 'src/app/main/shared/gis-dims-map/gis-dims-map.component';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { DEFAULT_CORRELATION_LAYER, URBAN_CORRELATION_LAYERS } from '../urban-heat-island-map/urban-heat-island-map-constants';
import { UrbanHeatIslandMapService } from '../urban-heat-island-map/urban-heat-island-map.service';

@Component({
  selector: 'app-urban-heat-island-sidebar',
  templateUrl: './urban-heat-island-sidebar.component.html',
  styleUrls: ['./urban-heat-island-sidebar.component.scss']
})
export class UrbanHeatIslandSidebarComponent implements OnInit, OnDestroy {
  queryParams: any = {};
  subscriptions: any = [];
  isInitialLoad: boolean = false;
  destroy: any = new Subject();
  sessionStorage: any = { params: {} };

  correlationTypes: any = Object.keys(URBAN_CORRELATION_LAYERS);
  selectedCorrelationType: string = DEFAULT_CORRELATION_LAYER;

  constructor(
    private utils: UtilsService,
    private dataService: DataService,
    private gisMapComp: GisDimsMapComponent,
    private urbanHeatIslandMapSrv: UrbanHeatIslandMapService
  ) { }

  ngOnInit() {
    this.isInitialLoad = true;
    this.subscribeEvents();
    this.setParams();
  }

  changeCorrelationLayer(type: string) {
    this.selectedCorrelationType = type;
    this.urbanHeatIslandMapSrv.switchCorrelationLayer(this.gisMapComp, type);
  }

  subscribeEvents() {
    const selectedParamsRef = this.utils.selectedParams.pipe(takeUntil(this.destroy)).subscribe((params: any) => {
      let sessionStorageSelectedParams: any = sessionStorage.getItem('params');
      if (Object.keys(params).length > 0) {
        this.queryParams = params;
      } else {
        this.queryParams = sessionStorageSelectedParams ? JSON.parse(sessionStorageSelectedParams) : {};
        this.sessionStorage.params = { ...this.queryParams };
        if (Object.keys(this.queryParams).length) {
          this.utils.setSelectedParams(this.queryParams);
        }
      }
    });
    this.subscriptions.push(selectedParamsRef);
  }

  setParams() {
    if (this.isInitialLoad && !Object.keys(this.sessionStorage.params).length) {
      this.requestSelectedFilterParams();
    }
    this.isInitialLoad = false;
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    if (!this.isInitialLoad) {
      currentUrlParams = this.queryParams;
    }
    currentUrlParams['component'] = 'URBANHEATISLAND';
    if (this.isInitialLoad) {
      let metaInfo: any = localStorage.getItem('metaInfo');
      let metaInfoJson: any = !isNullOrUndefined(metaInfo) ? JSON.parse(metaInfo) : {};
      let finalMetaInfo = metaInfoJson;
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'Admin';
      currentUrlParams['pType'] = 'DISTRICT';
      currentUrlParams['cType'] = 'WARD';
      currentUrlParams['dashboardView'] = 'INDIA';
      currentUrlParams['dashboardType'] = 'gis';
      currentUrlParams['pUUID'] = 'd7cf71c9-b149-49b9-8cd7-94641096d67f'; 
      currentUrlParams['locName'] = 'GURGAON';
      currentUrlParams['locType'] = 'DISTRICT';
      currentUrlParams['pEUUID'] = 'd7cf71c9-b149-49b9-8cd7-94641096d67f';

      currentUrlParams['location'] = 'GURGAON##d7cf71c9-b149-49b9-8cd7-94641096d67f';
      this.isInitialLoad = false;
    }
    this.utils.setSelectedParams(currentUrlParams);
  }


  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
    this.subscriptions.forEach((sub: any) => sub.unsubscribe());
  }
}
